import Layout from '@/cmp/templates/Layout/Layout'

export default Layout
